import { boolean, pgTable, text, timestamp, uuid } from "drizzle-orm/pg-core"
import { estates } from "./estate"

// Purpose: Stores personal care preferences for health directives and living wills
export const personalCare = pgTable("personal_care", {
  id: uuid("id").primaryKey().defaultRandom(),
  estateId: uuid("estate_id")
    .notNull()
    .unique()
    .references(() => estates.id, { onDelete: "cascade" }),

  // Medical Intervention Preferences (Boolean)
  cpr: boolean("cpr").default(false).notNull(),
  mechanicalVentilation: boolean("mechanical_ventilation").default(false).notNull(),
  artificialNutritionHydration: boolean("artificial_nutrition_hydration").default(false).notNull(),
  dialysis: boolean("dialysis").default(false).notNull(),
  antibioticsAntivirals: boolean("antibiotics_antivirals").default(false).notNull(),

  // Care Preferences (Text)
  comfortCare: text("comfort_care"),
  qualityOfLife: text("quality_of_life"),
  religiousSpiritualBeliefs: text("religious_spiritual_beliefs"),
  goalsOfCare: text("goals_of_care"),
  preferredLocation: text("preferred_location"),

  // Audit fields
  createdAt: timestamp("created_at").defaultNow().notNull(),
  updatedAt: timestamp("updated_at").defaultNow().notNull(),
})
